import { render, staticRenderFns } from "./OrdemDeCorte.vue?vue&type=template&id=6f7b775d&scoped=true&lang=pug"
import script from "./OrdemDeCorte.vue?vue&type=script&lang=js"
export * from "./OrdemDeCorte.vue?vue&type=script&lang=js"
import style0 from "./OrdemDeCorte.vue?vue&type=style&index=0&id=6f7b775d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7b775d",
  null
  
)

export default component.exports